import React from "react";
import { Box } from "@chakra-ui/react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";
import { NavbarWithCallToAction } from "../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { getColor } from "../../brandConfig";

const SurgreadyAssessmentModule: React.FC = () => (
  <Box bg={getColor("background.main")} minHeight="100vh" display="flex" flexDirection="column">
    <NavbarWithCallToAction />
    <Box flex="1">
      <ExcalidrawViewer
        filePath="/excalidraw/surgready-assessment-module.excalidraw"
        title="SurgReady Assessment & Snapshot Module"
        subtitle="Patient health assessments, radar chart tracking, snapshot comparisons, and admin oversight"
      />
    </Box>
    <FooterWithFourColumns />
  </Box>
);

export default SurgreadyAssessmentModule;
